<template>
    <div class="jobfair-detail">
        <div class="sub-content">
            <div class="bg">
                <img :src="bg_img" alt/>
            </div>
            <div class="content">
                <wy-card padding="0.2rem 0.15rem" :need-bottom="true">
                    <div>
                        <div>
                            <img style="max-width: 0.68rem;" :src="jobfairInfo.img+'?x-oss-process=style/w128-h128'"
                                 alt/>
                        </div>
                        <div class="jobfair-title">
              <span class="title-sm">
                {{jobfairInfo.name}}
                <van-button
                        plain
                        :type="jobfairInfo.current_status === '已结束'? 'default': 'info'"
                        size="mini"
                        class="btn"
                >{{jobfairInfo.current_status}}</van-button>
              </span>
                        </div>
                        <ul class="jobfair-introduce subtitle-sm">
                            <li>
                                <span class="iconfont icon-qiye"></span>
                                <span>{{jobfairInfo.organizers}}(主办方）</span>
                            </li>
                            <li v-if="jobfairInfo.co_organizer">
                                <span class="iconfont icon-qiye"></span>
                                <span>{{jobfairInfo.co_organizer}}(协办方）</span>
                            </li>
                            <li>
                                <span class="iconfont icon-qiye1"></span>
                                <span>预计参加企业{{jobfairInfo.nums}}家</span>
                            </li>
                            <li v-if="jobfairInfo.post_count">
                                <span class="iconfont icon-zhaopin"></span>
                                <span>岗位{{jobfairInfo.post_count || 0}}个</span>
                            </li>
                            <li v-if="jobfairInfo.seeker_numbs">
                                <span class="iconfont icon-dq-people"></span>
                                <span>求职者{{jobfairInfo.seeker_numbs || 0}}名</span>
                            </li>
                            <li v-if="jobfairInfo.view_nums">
                                <span class="iconfont icon-yanjing"></span>
                                <span>浏览{{jobfairInfo.view_nums || 0}}次</span>
                            </li>
                            <li>
                                <span class="iconfont icon-shijian"></span>
                                <span>{{jobfairInfo.start_time}}至{{jobfairInfo.end_time}}</span>
                            </li>
                        </ul>
                        <!--<div class="jobfair-btn" v-if="jobfairInfo.current_status !== '已结束'">
                          <van-button type="info" @click="signUpFn">
                            {{myApplyObj[jobfairInfo.video_jobfair_id] ? '进入会场': '报名进入会场'}}
                          </van-button>
                        </div>-->
                    </div>
                </wy-card>

                <wy-card>
                    <div class="jobfair-desc">
                        <div class="text-sm-title">双选会说明:</div>
                        <div class="text-sm jobfair-desc-text" v-html="jobfairInfo.jobfair_desc"></div>
                        <div class="text-sm-title" style="margin-top: 0.15rem;">求职者报名说明:</div>
                        <div class="text-sm jobfair-desc-text" v-html="jobfairInfo.seeker_register_desc"></div>
                    </div>
                </wy-card>
            </div>
        </div>
    </div>
</template>

<script>
  import WyCard from "@/components/WyCard";
  import {mapState} from "vuex";

  export default {
    name: "jobfair-detail",
    components: {WyCard},
    computed: {
      ...mapState({
        route: state => state.route,
        sign: state => state.sign,
        myApplyObj: state => state.myApplyObj,
        store_video_jobfair_id: state => state.video_jobfair_id
      })
    },
    data() {
      return {
        bg_img: "/img/bg.png",
        jobfair_img: "/img/company_logo.png",
        jobfairInfo: {},
        video_jobfair_id: ''
      };
    },
    created() {
      this.$store.commit("setSubTitle", {title: "双选会详情"});

      const video_jobfair_id = this.$util.getQueryString("video_jobfair_id") || this.store_video_jobfair_id;
      if (!video_jobfair_id) {
        this.$router.push({path: "/"});
      } else {
        this.video_jobfair_id = video_jobfair_id
        this.getDetail();
      }
    },
    methods: {
      getDetail() {
        let that = this;
        const {video_jobfair_id} = that;
        if (!video_jobfair_id) {
          that.$dialog
            .alert({
              title: "参数错误",
              message: "点击确定将回到视频双选会列表界面"
            })
            .then(() => {
              that.$router.push({path: "/"});
            });
          return;
        }

        return new Promise(resolve => {
          that.$util
            .get("kzp_video_jobfair", "video_jobfair_detail", {
              video_jobfair_id
            })
            .then(res => {
              const {code, msg, data} = res;

              if (code === 1) {
                that.$set(that, "jobfairInfo", data);
              } else {
                that.$notify({
                  message: msg || "获取数据失败，请稍后再试！",
                  type: "danger"
                });
              }

              resolve();
            });
        });
      },
      signUpFn() {
        let that = this;
        const {video_jobfair_id, myApplyObj, sign, jobfairInfo} = that;

        // 判断是否已报名
        if (!myApplyObj[video_jobfair_id]) {
          that.$store
            .dispatch("registerJobfair", {sign, video_jobfair_id})
            .then(res => {
              const {code, msg} = res;
              if (code === 1) {
                that.$dialog
                  .alert({
                    title: "报名成功!",
                    message: "简历完善度达到70%以上可获得更多面试机会哦!"
                  })
                  .then(() => {
                    that.toCompany(video_jobfair_id, jobfairInfo.name);
                  });
              } else {
                that.$notify({
                  message: msg || "获取数据失败，请稍后再试！",
                  type: "danger"
                });
              }
            });
          return;
        }

        that.toCompany(video_jobfair_id, jobfairInfo.name);
      },
      toCompany(video_jobfair_id, title) {
        this.$router.push({
          path:
          "/sub/company?video_jobfair_id=" +
          video_jobfair_id +
          "&title=" +
          title
        });
      }
    }
  };
</script>

<style lang="scss">
    .jobfair-desc-text {
        // text-indent: 2em;

        img {
            max-width: 100%;
        }
    }
</style>

<style lang="scss" scoped>
    .jobfair-detail {
        .sub-content {
            position: relative;
            height: 100%;
            width: 100%;

            > .bg {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
                overflow: hidden;

                img {
                    width: 100%;
                }
            }

            > .content {
                position: relative;
                z-index: 10;
                padding: 0.55rem 0.15rem 0.15rem;
                @include box-sizing(border-box);

                .jobfair-title {
                    padding: 0.12rem;
                    line-height: 0.2rem;
                    margin-bottom: 0.03rem;
                    text-align: center;

                    .title-sm {
                        display: inline-block;
                        max-width: 100%;
                        position: relative;
                        padding-right: 0.6rem;
                        @include box-sizing(border-box);
                        > .btn {
                            position: absolute;
                            right: 0;
                            top: 0.02rem;
                        }
                    }
                }

                .jobfair-introduce {
                    padding-left: 20%;
                    > li {
                        line-height: 0.17rem;
                        padding: 0.05rem 0 0.05rem 0.15rem;
                        text-align: left;
                        position: relative;
                    }
                    .iconfont {
                        position: absolute;
                        left: 0;
                        top: 0.05rem;
                        color: #3796ee;
                        font-size: 0.1rem;
                        line-height: 0.17rem;
                    }
                }

                .jobfair-btn {
                    margin-top: 0.15rem;
                }

                .jobfair-introduce > li,
                .jobfair-title .title-sm {
                    @include over-ellipsis();
                }

                .jobfair-desc {
                    text-align: left;
                    .jobfair-desc-text {
                        // text-indent: 2em;
                        @include over-wrap();
                    }
                }
            }
        }
    }
</style>
